export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20warm%20golden%20film%20reel%20and%20soft%20theater%20spotlight%20beams%20on%20deep%20charcoal%20backdrop%2C%20elegant%20minimal%20movie%20aesthetic%2C%20textured%20film%20grain%2C%20luxurious%20cinema%20atmosphere%2C%20no%20text%2C%20no%20people%2C%20atmospheric%20lighting%20with%20amber%20and%20crimson%20highlights%2C%20wide%20composition%20suitable%20for%20hero%20background&width=1800&height=900&seq=hero-cinema-bg-01&orientation=landscape"
          alt="8090影院电影主题背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-50/95"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/15 border border-accent-500/25 text-accent-400 text-xs font-medium mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>千万影迷的共同选择</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              8090影院
              <span className="block text-primary-500 mt-1">免费高清电影大全</span>
            </h1>

            <p className="text-lg sm:text-xl text-foreground-500 font-heading font-medium mb-6">
              国内外大片一网打尽 · 不缓冲不卡顿 · 无广告纯净观影
            </p>

            <p className="text-sm sm:text-base text-foreground-400 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              8090影院聚合海量免费电影大全资源，覆盖国内外大片、经典老片与最新热映。采用高速CDN加速技术打造不缓冲影院级播放体验，全程电影无广告干扰。每日更新片库，高清画质在线观看，让你随时随地畅享视听盛宴。本周热门专题聚焦暑期档新片速递与8090经典怀旧特辑，一站满足多元观影口味。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-1">高清影片资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/40 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">99.9%</div>
                <div className="text-xs text-foreground-500 mt-1">播放流畅率</div>
              </div>
              <div className="w-px h-10 bg-background-300/40 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">0广告</div>
                <div className="text-xs text-foreground-500 mt-1">纯净观影承诺</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-play-circle-fill mr-2"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100/80 hover:bg-background-100 text-foreground-700 hover:text-foreground-950 font-medium rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center border border-background-300/30"
              >
                <i className="ri-fire-line mr-2"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary-500/20 via-accent-500/20 to-primary-500/20 rounded-2xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20film%20collage%20composition%20with%20golden%20film%20strip%20curling%20across%20the%20frame%2C%20soft%20theater%20spotlight%20creating%20dramatic%20shadows%2C%20vintage%20movie%20ticket%20stubs%20and%20popcorn%20kernel%20textures%2C%20deep%20charcoal%20background%20with%20warm%20amber%20and%20crimson%20accents%2C%20luxurious%20and%20nostalgic%20movie%20theater%20atmosphere%2C%20no%20text%2C%20no%20human%20faces%2C%20artistic%20minimal%20design&width=1200&height=900&seq=hero-visual-cinema-01&orientation=portrait"
                  alt="8090影院主题视觉 - 电影元素艺术融合"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <div className="flex items-center gap-1.5 bg-background-50/80 backdrop-blur-sm rounded-full px-3 py-1.5">
                    <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                    <span className="text-foreground-700 text-xs font-medium">日均更新50+部</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}